import { Component, Inject, OnInit } from '@angular/core';
import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import { ModalService } from '@core/services/modal/modal.service';

@Component({
	selector: 'app-retailer-select-modal',
	templateUrl: './retailer-select-modal.component.html',
	styleUrls: ['./retailer-select-modal.component.scss', './retailer-select-modal.responsive.scss'],
})
export class RetailerSelectModalComponent implements OnInit {
	constructor(
		public dialogRef: MatDialogRef<RetailerSelectModalComponent>,
		@Inject(MAT_DIALOG_DATA) public data: boolean,
		private modalService: ModalService,
	) {}

	ngOnInit() {
		this.modalService.liftUpModal(this.dialogRef);
	}

	close(): void {
		this.dialogRef.close();
	}

	delete(): void {
		this.dialogRef.close(true);
	}
}
